import React, {Fragment, useEffect, useState} from 'react'
import {makeStyles} from '@material-ui/core'
import useLanguage from 'features/languageReport/useLanguage'
import HealthCenterReportStyle from 'pages/HealthCenter/Report/Style'
import {HealthReport, HealthyCheckupReport} from 'api/healthCareApi'
import Header from 'pages/HealthCenter/Report/Elements/Header'
import HealthCenterMajorIndicators from 'pages/HealthCenter/Report/HealthCenterMajorIndicators'
import HealthCenterMajorIndicatorsV1 from 'pages/HealthCenter/ReportV1/HealthCenterMajorIndicators'
import {useTranslation} from 'react-i18next'
import BrainFunctionBasic from 'pages/HealthCenter/Report/BrainFunctionBasic'
import BrainFunctionBasicV1 from 'pages/HealthCenter/ReportV1/BrainFunctionBasic'
import {GenderValue, toGenderString} from 'constants/CommonConstant'
import TablePrintF8 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintF8'
import TablePrintF8V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintF8'
import TablePrintF1 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintF1'
import TablePrintF1V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintF1'
import TablePrintT1 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintT1'
import TablePrintT1V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintT1'
import TablePrintT6 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintT6'
import TablePrintT6V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintT6'
import TablePrintP1 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintP1'
import TablePrintP1V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintP1'
import TablePrintO1 from 'pages/HealthCenter/Report/BrainFunctionMapping/Elements/tablePrintO1'
import TablePrintO1V1 from 'pages/HealthCenter/ReportV1/BrainFunctionMapping/Elements/tablePrintO1'
import PagePrintWrap1 from 'pages/HealthCenter/Report/BrainFunctionalConnectivity/Elements/pagePrintWrap1'
import PagePrintWrap1V1 from 'pages/HealthCenter/ReportV1/BrainFunctionalConnectivity/Elements/pagePrintWrap1'
import PagePrintWrap2 from 'pages/HealthCenter/Report/BrainFunctionalConnectivity/Elements/pagePrintWrap2'
import PagePrintWrap2V1 from 'pages/HealthCenter/ReportV1/BrainFunctionalConnectivity/Elements/pagePrintWrap2'
import PagePrintWrap3 from 'pages/HealthCenter/Report/BrainFunctionalConnectivity/Elements/pagePrintWrap3'
import PagePrintWrap3V1 from 'pages/HealthCenter/ReportV1/BrainFunctionalConnectivity/Elements/pagePrintWrap3'
import AIDementiaPrediction from 'pages/HealthCenter/Report/AIDementiaPrediction'
import AIDementiaPredictionV1 from 'pages/HealthCenter/ReportV1/AIDementiaPrediction'
import HealthCenterHeartRateAnalysisPage from 'pages/HealthCenter/Report/HealthCenterHeartRateAnalysis'
import HealthCenterHeartRateAnalysisPageV1 from 'pages/HealthCenter/ReportV1/HealthCenterHeartRateAnalysis'
import PrintComponent from 'pages/HealthCenter/Report/Elements/PrintComponent'
import AIDementiaPredictionV2 from 'pages/HealthCenter/ReportV2/AIDementiaPrediction'
import {useAppSelector} from 'hooks'
import {
  getCurrentLanguageReport,
  selectLanguageReport,
} from 'features/languageReport/languageReportSlice'
import {ResMCIV2} from 'api/languageApi'
import i18n from 'i18n'
import HeaderMultiLangReport from './HeaderMultiLang'

const useStyles = makeStyles(HealthCenterReportStyle)

type PropsType = {
  dataHealthReport: HealthReport
  dataHealthCheckupReport: HealthyCheckupReport
  listTab: number[]
  DATA_TITLE: string[][]
  isLocalLanguage: boolean
  isVersion2: boolean
}

const getNumber = (value: number | string) => {
  if (!Number.isNaN(Number(value))) return Number(value)
  return 0
}

const WrapPrintPage = ({
  dataHealthReport,
  dataHealthCheckupReport,
  listTab,
  DATA_TITLE,
  isLocalLanguage,
  isVersion2,
}: PropsType) => {
  const classes = useStyles()
  const {t} = useTranslation()
  const [components, setComponents] = useState<React.ReactElement[]>([])
  const languageReport = useAppSelector((state) =>
    selectLanguageReport(state.languageReport),
  )
  const currentLanguageReport = getCurrentLanguageReport(
    languageReport,
    i18n.language,
  )
  const {textHealthAPI} = useLanguage('health')

  const baseLobeScores = {
    Frontal_LH: 0,
    Frontal_RH: 0,
    Occipital_LH: 0,
    Occipital_RH: 0,
    Parietal_LH: 0,
    Parietal_RH: 0,
    Temporal_LH: 0,
    Temporal_RH: 0,
  }

  const getTitleHeader = (tabActive: number): string => {
    if (!isLocalLanguage && currentLanguageReport?.health) {
      if (tabActive === 0) {
        return currentLanguageReport.health.five_major_features.title
      }
      if (tabActive === 1) {
        return currentLanguageReport.health.brain_mapping.basic.title
      }
      if (tabActive === 2) {
        return currentLanguageReport.health.brain_mapping.advanced.title
      }
      if (tabActive === 3) {
        return currentLanguageReport.health.brain_connectivity.title.toString()
      }
      if (tabActive === 4) {
        return currentLanguageReport.health.mci.title
      }
      if (tabActive === 5) {
        return currentLanguageReport.health.hrv_analysis.title
      }
    }
    return ''
  }
  const generateHeader = (
    idxTitle1: number,
    idxTitle2: number,
    idxContent1: number,
    idxContent2: number,
  ) => {
    return (
      <>
        {isLocalLanguage ? (
          <Header
            title={DATA_TITLE[idxTitle1][idxTitle2]}
            content={DATA_TITLE[idxContent1][idxContent2]}
            name={t('IGetFullName', {
              firstName: dataHealthReport.patientFirstName ?? '',
              lastName: dataHealthReport.patientLastName ?? '',
            })}
            sex={t(
              toGenderString(dataHealthReport.patientGender as GenderValue),
            )}
            birthday={dataHealthReport.patientBirth}
            measurementDate={
              dataHealthReport.displayMeasurementDateTime ??
              dataHealthReport.treatmentAt
            }
          />
        ) : (
          <HeaderMultiLangReport
            title={getTitleHeader(idxTitle1)}
            content={DATA_TITLE[idxContent1][idxContent2]}
            name={t('IGetFullName', {
              firstName: dataHealthReport.patientFirstName ?? '',
              lastName: dataHealthReport.patientLastName ?? '',
            })}
            sex={t(
              toGenderString(dataHealthReport.patientGender as GenderValue),
            )}
            birthday={dataHealthReport.patientBirth}
            measurementDate={
              dataHealthReport.displayMeasurementDateTime ??
              dataHealthReport.treatmentAt
            }
            titleHeader={currentLanguageReport?.health?.header as any}
            tabIndex={idxTitle1}
          />
        )}
      </>
    )
  }

  useEffect(() => {
    const Screen1: React.FC = () => (
      <div id='health-center'>
        {generateHeader(0, 0, 0, 1)}
        {dataHealthCheckupReport?.scores?.brain_top_indicators !== null ? (
          <Fragment>
            {isLocalLanguage ? (
              <HealthCenterMajorIndicators
                fiveFeaturesRadarImage={
                  dataHealthCheckupReport?.images?.radar_chart
                }
                fiveFeaturesScore={
                  dataHealthCheckupReport?.scores?.brain_top_indicators
                }
                scoreAnnotation={
                  textHealthAPI?.common?.score_annotation?.t_score ?? ''
                }
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
              />
            ) : (
              <HealthCenterMajorIndicatorsV1
                fiveFeaturesRadarImage={
                  dataHealthCheckupReport?.images?.radar_chart
                }
                fiveFeaturesScore={
                  dataHealthCheckupReport?.scores?.brain_top_indicators
                }
                isEEG={false}
                scoreAnnotation={
                  textHealthAPI?.common?.score_annotation?.t_score ?? ''
                }
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
              />
            )}
          </Fragment>
        ) : (
          <div className={classes.hrvError}>{t('IFiveBrainFunctionNull')}</div>
        )}
      </div>
    )
    const Screen2: React.FC = () => (
      <div id='health-center'>
        {generateHeader(1, 0, 1, 1)}

        {dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score !==
        null ? (
          <Fragment>
            {isLocalLanguage ? (
              <BrainFunctionBasic
                agingThreeDimensionImage={
                  dataHealthCheckupReport.images.three_dim
                }
                agingContourImage={dataHealthCheckupReport.images.contour}
                agingLobeScore={
                  dataHealthCheckupReport?.scores?.brain_mapping_basic
                    ?.lobe_score ?? baseLobeScores
                }
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
                isPrint
              />
            ) : (
              <BrainFunctionBasicV1
                agingThreeDimensionImage={
                  dataHealthCheckupReport.images.three_dim
                }
                agingContourImage={dataHealthCheckupReport.images.contour}
                agingLobeScore={
                  dataHealthCheckupReport?.scores?.brain_mapping_basic
                    ?.lobe_score
                }
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
                isPrint
              />
            )}
          </Fragment>
        ) : (
          <div className={classes.hrvError}>
            {t('IBrainFunctionBasicMappingNull')}
          </div>
        )}
      </div>
    )
    const Screen3: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}
        (
        <TablePrintF1V1
          Frontal_LH={getNumber(
            dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
              ?.Frontal_LH ?? 0,
          )}
          Temporal_LH={getNumber(
            dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
              ?.Frontal_RH ?? 0,
          )}
          agingRoiScore={
            dataHealthCheckupReport?.scores?.brain_mapping_advanced
          }
        />
        )
      </div>
    )

    const Screen4: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}

        {isLocalLanguage ? (
          <TablePrintF8
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        ) : (
          <TablePrintF8V1
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        )}
      </div>
    )

    const Screen5: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}

        {isLocalLanguage ? (
          <TablePrintT1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Temporal_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Temporal_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        ) : (
          <TablePrintT1V1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Temporal_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Temporal_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        )}
      </div>
    )

    const Screen6: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}

        {isLocalLanguage ? (
          <TablePrintT6
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        ) : (
          <TablePrintT6V1
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        )}
      </div>
    )

    const Screen7: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}

        {isLocalLanguage ? (
          <TablePrintP1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Parietal_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Parietal_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        ) : (
          <TablePrintP1V1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Parietal_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                ?.Parietal_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        )}
      </div>
    )

    const Screen8: React.FC = () => (
      <div id='health-center'>
        {generateHeader(2, 0, 2, 1)}

        {isLocalLanguage ? (
          <TablePrintO1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                .Occipital_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                .Occipital_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        ) : (
          <TablePrintO1V1
            Frontal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                .Occipital_LH ?? 0,
            )}
            Temporal_LH={getNumber(
              dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score
                .Occipital_RH ?? 0,
            )}
            agingRoiScore={
              dataHealthCheckupReport?.scores?.brain_mapping_advanced
            }
          />
        )}
      </div>
    )

    const Screen9: React.FC = () => (
      <div id='health-center'>
        {generateHeader(3, 0, 3, 1)}

        {isLocalLanguage ? (
          <PagePrintWrap1
            partOneImg={dataHealthCheckupReport.images.total_connection}
            brainConnectivityTotalScore={
              dataHealthCheckupReport.scores.brain_connectivity.total
            }
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        ) : (
          <PagePrintWrap1V1
            partOneImg={dataHealthCheckupReport.images.total_connection}
            brainConnectivityTotalScore={
              dataHealthCheckupReport.scores.brain_connectivity.total
            }
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        )}
      </div>
    )

    const Screen10: React.FC = () => (
      <div id='health-center'>
        {generateHeader(3, 0, 3, 1)}

        {isLocalLanguage ? (
          <PagePrintWrap2
            partTwoImg={dataHealthReport.brainConnectivityBetweenLobesImage}
            partThreeImg={dataHealthReport.brainConnectivityByLobeImage}
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        ) : (
          <PagePrintWrap2V1
            partTwoImg={dataHealthReport.brainConnectivityBetweenLobesImage}
            partThreeImg={dataHealthReport.brainConnectivityByLobeImage}
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        )}
      </div>
    )
    const Screen13: React.FC = () => (
      <div id='health-center'>
        {generateHeader(3, 0, 3, 1)}

        {isLocalLanguage ? (
          <PagePrintWrap3
            partTwoImg={dataHealthReport.brainConnectivityBetweenLobesImage}
            partThreeImg={dataHealthReport.brainConnectivityByLobeImage}
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        ) : (
          <PagePrintWrap3V1
            partTwoImg={dataHealthReport.brainConnectivityBetweenLobesImage}
            partThreeImg={dataHealthReport.brainConnectivityByLobeImage}
            brainConnectivityBetweenLobesScore={
              dataHealthCheckupReport.scores.brain_connectivity.inter
            }
            brainConnectivityByLobeScore={
              dataHealthCheckupReport.scores.brain_connectivity.intra
            }
          />
        )}
      </div>
    )
    const Screen11: React.FC = () => (
      <div id='health-center'>
        {generateHeader(4, 0, 4, 1)}

        {isLocalLanguage && !isVersion2 && (
          <AIDementiaPrediction
            mciResultImage={dataHealthCheckupReport.images.mci_aging_curve}
            mciProbability={dataHealthCheckupReport.scores.dementia_prediction}
            name={t('IGetFullName', {
              firstName: dataHealthReport.patientFirstName ?? '',
              lastName: dataHealthReport.patientLastName ?? '',
            })}
            footer={textHealthAPI?.common?.footer?.[0] ?? ''}
          />
        )}
        {isVersion2 && (
          <AIDementiaPredictionV2
            mciResultImage={dataHealthCheckupReport.images.mci_aging_curve}
            mciProbability={dataHealthCheckupReport.scores.dementia_prediction}
            name={t('IGetFullName', {
              firstName: dataHealthReport.patientFirstName ?? '',
              lastName: dataHealthReport.patientLastName ?? '',
            })}
            textMCI={currentLanguageReport?.health?.mci as ResMCIV2}
            footer={textHealthAPI?.common?.footer?.[0] ?? ''}
          />
        )}
        {!isLocalLanguage && !isVersion2 && (
          <AIDementiaPredictionV1
            mciResultImage={dataHealthCheckupReport.images.mci_aging_curve}
            mciProbability={dataHealthCheckupReport.scores.dementia_prediction}
            name={t('IGetFullName', {
              firstName: dataHealthReport.patientFirstName ?? '',
              lastName: dataHealthReport.patientLastName ?? '',
            })}
            textMCI={currentLanguageReport?.health?.mci as any}
            footer={textHealthAPI?.common?.footer?.[0] ?? ''}
          />
        )}
      </div>
    )

    const Screen12: React.FC = () => (
      <div id='health-center'>
        {dataHealthCheckupReport.scores.hrv_analysis !== null ? (
          <>
            {generateHeader(5, 0, 5, 1)}

            {isLocalLanguage ? (
              <HealthCenterHeartRateAnalysisPage
                hrvTableImage={dataHealthCheckupReport.images.hrv_table}
                hrvCircularImage={dataHealthCheckupReport.images.hrv_circular}
                hrvAutoNervousSystemBalance={
                  dataHealthCheckupReport.scores.hrv_analysis
                    .auto_nervous_system_balance
                }
                hrvContourImage={dataHealthCheckupReport.images.hrv_contour}
                hrvHistogramImage={dataHealthCheckupReport.images.hrv_histogram}
                hrvCircularLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.circular_level
                }
                hrvContourLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.contour_level
                }
                hrvHistogramLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.histogram_level
                }
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
              />
            ) : (
              <HealthCenterHeartRateAnalysisPageV1
                hrvTableImage={dataHealthCheckupReport.images.hrv_table}
                hrvCircularImage={dataHealthCheckupReport.images.hrv_circular}
                hrvAutoNervousSystemBalance={
                  dataHealthCheckupReport.scores.hrv_analysis
                    .auto_nervous_system_balance
                }
                hrvContourImage={dataHealthCheckupReport.images.hrv_contour}
                hrvHistogramImage={dataHealthCheckupReport.images.hrv_histogram}
                hrvCircularLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.circular_level
                }
                hrvContourLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.contour_level
                }
                hrvHistogramLevel={
                  dataHealthCheckupReport.scores.hrv_analysis.histogram_level
                }
                textHRV={currentLanguageReport?.health?.hrv_analysis as any}
                footer={textHealthAPI?.common?.footer?.[0] ?? ''}
              />
            )}
          </>
        ) : (
          <>
            {generateHeader(5, 0, 5, 1)}

            <div className={classes.hrvError}>{t('IHrvErrorText')}</div>
          </>
        )}
      </div>
    )

    const dataScreen = [
      [<Screen1 />],
      [<Screen2 />],
      [
        <Screen3 />,
        <Screen4 />,
        <Screen5 />,
        <Screen6 />,
        <Screen7 />,
        <Screen8 />,
      ],
      [<Screen9 />, <Screen10 />, <Screen13 />],
      [<Screen11 />],
      [<Screen12 />],
    ]

    const newComponents: React.ReactElement[] = []

    listTab.forEach((tab) => {
      if (
        !(
          (tab === 0 &&
            dataHealthCheckupReport?.scores?.brain_top_indicators === null) ||
          (tab === 1 &&
            dataHealthCheckupReport?.scores?.brain_mapping_basic?.lobe_score ===
              null) ||
          (tab === 2 &&
            dataHealthCheckupReport?.scores?.brain_mapping_advanced === null) ||
          (tab === 3 &&
            dataHealthCheckupReport?.scores?.brain_connectivity?.intra ===
              null) ||
          (tab === 4 &&
            dataHealthCheckupReport?.scores?.dementia_prediction === null) ||
          (tab === 5 && dataHealthCheckupReport?.scores?.hrv_analysis === null)
        )
      ) {
        newComponents.push(...dataScreen[tab])
      }
    })

    setComponents(newComponents)
  }, [
    dataHealthReport,
    dataHealthCheckupReport,
    isLocalLanguage,
    isVersion2,
    currentLanguageReport,
  ])

  return (
    <div>
      <PrintComponent components={components} />
    </div>
  )
}

export default WrapPrintPage
